import { config } from '../config';
import { isAllowedUser } from './authPolicy';
import { usePasskey } from './passkeys';

export async function authRequest(endpoint, body, token = localStorage.getItem('token')) {
    const response = await fetch(`${config.apiBase}/auth/${endpoint}`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
        body: JSON.stringify(body), cache: 'no-store'
    });
    let data;
    try { data = await response.json(); } catch { throw new Error('Connexion au serveur impossible. Réessayez dans un instant.'); }
    if (!response.ok || !data.success) throw new Error(data.message || 'La connexion a échoué. Réessayez.');
    return data;
}
export async function completeDeviceLogin(ticket, onMode = () => {}) {
    let challenge = ticket;
    for (let i = 0; i < 2; i++) {
        const data = await authRequest('passkey.php', { action: 'options', challenge });
        if (data.pending_approval || !['create', 'get'].includes(data.mode)) throw new Error('Mettez à jour les fichiers PHP pour activer l’enregistrement automatique.');
        onMode(data.mode);
        const credential = await usePasskey(data.options, data.mode);
        const result = await authRequest('passkey.php', { action: 'finish', challenge, credential });
        if (result.passkey_registered && result.challenge) { challenge = result.challenge; continue; }
        if ((result.token && isAllowedUser(result.user)) || result.privileged_required || result.enrolled) return result;
        throw new Error('L’enregistrement de votre appareil n’a pas pu être terminé. Réessayez.');
    }
    throw new Error('Recommencez la vérification de votre appareil.');
}
export function saveAuthSession(data, notify = true) {
    if (!data.token || !isAllowedUser(data.user)) throw new Error('La vérification de votre appareil est nécessaire.');
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
    localStorage.setItem('last_login_identifier', data.user.email || data.user.telephone || '');
    if (notify) {
        window.dispatchEvent(new CustomEvent('authChange'));
        window.dispatchEvent(new Event('storage'));
    }
}
